import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';
import UUID from 'uuid-js';
import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    orderDetails: {
      embedded: 'always'
    }
  },
  keyForRelationship(key) {
    const underscored = underscore(key);
    switch (key) {
      case 'subscriptionPlans':
        return `${underscored.slice(0, -1)}_ids`;
      case 'orderDetails':
      default:
        return underscored;
    }
  },
  normalize(type, payload) {
    const newPayload = {
      ...payload
    };
    newPayload.id = UUID.create().toString();
    return this._super(type, newPayload);
  },
  serialize(snapshot) {
    return this._super(snapshot, {
      includeId: false
    });
  }
});